import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=7dd7d434"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
